/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import polygonPng from 'images/polygon.png';
import { Tooltip } from 'react-bootstrap';
import OverlayTriggerWrapper from 'comps/OverlayTriggerWrapper';
import { useEffect } from 'react';
import { set, state, q } from 'ops';
import PATHS from 'const/paths';
import * as db from 'lib/db';
import isSmallScreen from 'lib/isSmallScreen';
import useStoreState from 'lib/useStoreState';
import useCommands from 'comps/Left2/useCommands';
import cx from 'classnames';

const openText = 'Open Map Areas';
const hideText = 'Close Map Areas';
const lightBlue = '#2e7fcf';

function invalidateMapSize() {
  window.cityMap && window.cityMap.invalidateSize();
}

function useLocalStateValue() {
  useEffect(() => {
    setTimeout(() => {
      set(PATHS.hideRightSidebar, db.read('hideRightSidebar'));
      invalidateMapSize();
    }, 100);
  }, []);
}

function useHidden() {
  useStoreState({
    isHidden: PATHS.hideRightSidebar,
  });
  const isHidden = db.read('hideRightSidebar');
  return isHidden === 'true' || isHidden === true;
}

function useTooltipText() {
  const isHidden = useHidden();
  return isHidden ? openText : hideText;
}

const ToggleSidebarBtn2 = () => {
  const isHidden = useHidden();
  const html = useTooltipText();
  const cmd = useCommands();

  function onToggle() {
    // DEPRECATED: Get this value from Left2 context.
    const panel = state(PATHS.activePanelName);
    if (panel && isSmallScreen()) {
      cmd.closePanel();
    }
    q((v) => v.delete('area_id'));
    db.toggle('hideRightSidebar');
    const isHidden2 = db.read('hideRightSidebar') === 'true';
    setTimeout(() => {
      set(PATHS.hideRightSidebar, isHidden2);
      invalidateMapSize();
    }, 100);
  }

  useLocalStateValue();

  if (isSmallScreen()) return null;

  return (
    <div data-testid="ToggleSidebarBtn2" onClick={onToggle}>
      <OverlayTriggerWrapper
        placement="left"
        trigger={['hover']}
        overlay={
          <Tooltip id="toggle-right-sidebar">
            <span dangerouslySetInnerHTML={{ __html: html }} />
          </Tooltip>
        }
      >
        <a
          id="toggle-right-sidebar"
          css={css(`
            color: white;
            background: ${lightBlue};
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-content: stetch;
            cursor: pointer;

            @media (max-width: 490px) {
              display: none;
            }
          `)}
          onClick={() => {}}
        >
          <div
            css={css(`
          font-size: 1.4em;
          padding: 10px;
        `)}
          >
            <img
              src={polygonPng}
              css={css(`
                  width: 15px;
              `)}
            />
          </div>
          <div className="d-flex align-items-center pl-3 pr-3 border-left">
            <i
              css={css(`
                font-size: 2rem;
                font-weight: 400;
                color: white;
              `)}
              className={cx('fa', {
                'fa-angle-left': isHidden,
                'fa-angle-right': !isHidden,
              })}
            />
          </div>
        </a>
      </OverlayTriggerWrapper>
    </div>
  );
};

export default (ToggleSidebarBtn2: any);
